/* tslint:disable:typedef-whitespace no-trailing-whitespace */
// noinspection CssUnknownTarget

import {TaskUpdate, TaskUpdateType} from "@/models/task.update";
import {basename} from "@/util/util";

/**
 *
 * @class TaskMergeDiamondCrossingsFailed
 *
 * @brief sentinel progress event; diamond crossings merging failed
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2024
 *
 */
export class TaskMergeDiamondCrossingsFailed extends TaskUpdate {


  /**  the blob key or file name being uploaded */
  public fileName: string;

  /** the error message */
  public message: string;

  /** the icon to use for the file type */
  public icon:     string;

  /**
   * standard constructor, you have to uniquely identify the task progress stream (id)
   * and provide the type of progress update (type).
   *
   * @param id       the unique id of the task progress stream to clear (the context)
   * @param fileName the blob key or file name being uploaded
   * @param message  the error message
   * @param icon     the icon to use for the file type
   *
   */
  constructor(id: string, fileName: string, message: string, icon: string='blob-diamond-error-32.png') {

    super(id, TaskUpdateType.Complete,100.0);

    this.fileName = fileName;
    this.icon     = icon;
    this.message  = this.errorToString(message);

  }

  /** subclasses that can render their own update should return non-empty HTML */
  render(): string {

    let label:    string = basename(this.fileName);

    return `
<div class="task-file-upload-sub-panel">

  <div style="display: inline-block; width: 32px;">
    <img alt="merging diamond crossings, failed." class="tsp-icon" src="/assets/images/blob-icons/${this.icon}" width="32"></img>
  </div>

  <div style="display: inline-block; width: calc(100% - 40px);">

    <div style="display: block;">
      <span class="tsp-label">${label}</span>
    </div>

    <div style="display: block;">
      <span class="tsp-size">[Merge] ${this.message}</span>
    </div>

  </div>

</div>`;
  }

  /** is this task complete? */
  isComplete(): boolean {

    return true;
  }

}
